/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2530
 */

var r = require(/* 2531 */"./2531")
var i = require(/* 2532 */"./2532")
module.exports = function (e, t) {
  return null != e && i(e, t, r)
}
